import React, { Component } from 'react';
import InputForm from '../InputForm';
import $ from 'jquery'

class TableForm extends Component {

    state = {
        //data:{},

        id: "",
        text: "",
        width: "",
        offset: "",
        thead: [],
        rows: [],
        required: false,
        hidden: "",

        newline: {}
    }

    counter = 0;
    getCounter = () => {
        return this.counter++
    }

    //initial state
    constructor(props) {
        super(props)

        this.state.id = props.data.domain;
        this.state.text = props.data.text;
        this.state.width = props.data.width;
        this.state.offset = props.data.offset;
        this.state.required = props.required;
        this.state.hidden = props.data.hidden;

        //initializing thead and tbody
        this.state.thead = props.data.table_data['thead'];
        this.state.rows = props.data.table_data['tbody'];

        //Creating image row in case of addition of new rows
        var updated_controls = Object.values(JSON.parse(JSON.stringify(this.state.rows.slice(-1)[0])));
        for (var i = 0; i < updated_controls.length; i++) {
            //while (controls.length){
            var control = updated_controls[i];
            switch (control.mode.toLowerCase()) {
                case "literal":
                    control.values = "";
                    break;
                case "inputnumber":
                    control.defaultValue = "";
                    break;
                case "inputtext":
                    control.defaultValue = "";
                    break;
                case "select":
                    control.defaultValue = "";
                    break;
                case "filter":
                    control.defaultValue = "";
                    break;
                default:
                //doing nothing
            }
        }
        this.state.newline = updated_controls;
    }

    /**
     * Create a new structure of results of table (props.dataResults). 
     * This structure will be filled when their components change
     * This structure will be sent in the urls like other components out of the table
     * In case of new rows, these will be added, keeping the current elements in props.dataResults
     */
    generateTableStructure = () => {
        var table_out_data = [];
        if (this.props.dataResult.TABLE !== undefined) {
            table_out_data = this.props.dataResult.TABLE;
        }
        for (var i = 0; i < this.state.rows.length; i++) {
            // In case of new rows, these will be added, keeping the current elements in props.dataResults
            if (table_out_data[i] === undefined) {
                var elementsInRow = Object.keys(this.state.rows[i]);
                var row = {}
                for (var j = 0; j < elementsInRow.length; j++) {
                    var domain = this.state.rows[i][elementsInRow[j]].domain;
                    var defaultValue = this.state.rows[i][elementsInRow[j]].defaultValue;
                    if (domain == null) {
                        domain = this.state.rows[i][elementsInRow[j]].text;
                        defaultValue = this.state.rows[i][elementsInRow[j]].values;
                    }
                    row[domain] = defaultValue;
                }
                table_out_data[i] = row;
            }
        }
        this.props.dataResult.TABLE = table_out_data;
    }

    handleAddRow = () => {
        //this.updateRows();
        this.state.rows.push(this.state.newline);
        this.setState(this.state.rows);
    }

    handleRemoveRow = (row_index) => {
        this.props.dataResult.TABLE[row_index].disabled = true;

        $("#tr-" + row_index).css('display', 'none');
    };

    render() {
        this.generateTableStructure();
        return (
            <div className="col-12" hidden={this.state.hidden || ''}>
                <label htmlFor={this.state.id}>
                    {this.state.text}
                </label>
                <button type="button" onClick={this.handleAddRow} className="btn btn-success pull-right">Add row</button>
                <div className="kt-section">
                    <div className="kt-section__content">
                        <table className="table table-bordered table-hover table-responsive" id={this.state.id}
                            name={this.state.id} defaultValue={''}>
                            <thead>
                                <tr>
                                    <th className="percent1" scope="col"></th>
                                    {this.state.thead.map((item, index) => (
                                        <th className={this._generateThClasses(item)} scope="col">{item.text}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.rows.map((row, row_index) => (
                                    <tr key={'tr-' + row_index} id={'tr-' + row_index}>
                                        <td><button type="button" onClick={() => this.handleRemoveRow(row_index)} className="btn btn-danger">-</button></td>
                                        {Object.keys(row).map((cell, cell_index) => (
                                            <td key={'tr-' + cell_index}>
                                                <InputForm key={"form-" + cell_index} ref={row[cell].text} dataJson={row} elementForm={cell} dataResult={this.props.dataResult} showLabel={false} rowIndex={row_index} />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    _generateThClasses(item) {
        let retVal = ' ';
        if (item.width) {
            retVal += `percent${item.width} `;
        }
        if (item.minWidth) {
            retVal += `min-width${item.minWidth}`;
        }
        return retVal;
    }
}

export default TableForm;